module.exports = __webpack_public_path__ + "img/header-kz.3f328852.jpg";